import React from 'react'
import { BookingFormHeader } from '../Common/BookingFormHeader'
import { FormBanner } from './FormBanner'
import { BookingForm } from './BookingForm'
import { BookingFooter } from '../Common/BookingFooter'
import '../../../../BookingPage.css';
import { useLocation } from 'react-router-dom'

export const MainPage = () => {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const pid = queryParams.get('pid');
    const propertyID = location.state?.PropertyID;
    // console.log("PID:", pid);
    // console.log("PropertyID:", propertyID);
    const checkInDate = location.state?.checkInDate;
    const checkOutDate = location.state?.checkOutDate;
    return (
        <>
            <BookingFormHeader />
            <FormBanner
                checkInDate={checkInDate}
                checkOutDate={checkOutDate}
            />
            <BookingForm pid={pid} propertyID={propertyID} />
            <BookingFooter />
        </>
    )
}
